import React from "react";
import { Link } from "react-router-dom";
import { Home, Store, PackageSearch } from "lucide-react";
import Header from "./Header";
import Footer from "./Footer";
import useNoIndex from "../hooks/useNoIndex";
import useSeo from "../hooks/useSeo";
import { SERVICE_LINKS } from "../seoContent";

export default function NotFound() {
  useNoIndex();
  useSeo({
    title: "Page Not Found (404) | Kapatia Pvt Ltd",
    description: "The page you are looking for could not be found. Browse Kapatia's IT equipment services, store and service areas.",
  });
  return (
    <div className="public-site" style={{ background: "var(--cream)" }}>
      <Header />
      <main className="container" data-testid="not-found-page" style={{ minHeight: "60vh", paddingTop: 64, paddingBottom: 64 }}>
        <div className="grid place-items-center gap-4 text-center">
          <PackageSearch size={44} style={{ color: "var(--orange-700)" }} />
          <p className="font-heading font-extrabold" style={{ color: "var(--orange-700)", letterSpacing: "0.12em" }}>404</p>
          <h1 className="font-heading font-extrabold leading-tight" style={{ color: "var(--green-950)", fontSize: "clamp(28px,4vw,44px)" }}>
            This page could not be found
          </h1>
          <p className="max-w-[560px] text-[16px]" style={{ color: "#31463a" }}>
            The link may be broken or the page may have moved. Let's get you back on track.
          </p>
          <div className="mt-2 flex flex-wrap justify-center gap-3">
            <Link to="/" data-testid="notfound-home"
                  className="kp-button inline-flex items-center gap-2 rounded-full px-6 py-3 font-heading text-[14px] font-bold text-white"
                  style={{ background: "linear-gradient(135deg, var(--green-800), var(--green-950))" }}>
              <Home size={16} /> Go to homepage
            </Link>
            <Link to="/store" data-testid="notfound-store"
                  className="kp-button inline-flex items-center gap-2 rounded-full border bg-white px-6 py-3 font-heading text-[14px] font-bold"
                  style={{ borderColor: "var(--line)", color: "var(--green-900)" }}>
              <Store size={16} /> Browse the store
            </Link>
          </div>
          <nav aria-label="Popular services" className="mt-6 flex flex-wrap justify-center gap-2">
            {SERVICE_LINKS.slice(0, 8).map((l) => (
              <Link key={l.href} to={l.href}
                    className="inline-flex rounded-full border bg-white px-4 py-2 font-heading text-[13px] font-bold"
                    style={{ borderColor: "var(--line)", color: "var(--green-900)" }}>
                {l.label}
              </Link>
            ))}
          </nav>
        </div>
      </main>
      <Footer />
    </div>
  );
}
